module.exports = __webpack_public_path__ + "static/darwin-01-ee2234f6e2f4bf1271b81ab76611b362.jpg";